import { render, staticRenderFns } from "./manualDistribute.vue?vue&type=template&id=83727468&scoped=true"
import script from "./manualDistribute.vue?vue&type=script&lang=js"
export * from "./manualDistribute.vue?vue&type=script&lang=js"
import style0 from "./manualDistribute.vue?vue&type=style&index=0&id=83727468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83727468",
  null
  
)

export default component.exports